import { atom } from 'recoil'

// 加企微弹窗
export const addProWxWinState = atom<boolean>({
  key: 'addProWxWin',
  default: false
})

// 二维码
export const proWxWinEqState = atom<string>({
  key: 'proWxWinEq',
  default: ''
})

// 资金监管 用户点击弹窗上报
export const fundSupervisionPopState = atom<boolean>({
  key: 'fundSupervisionPop',
  default: false
})

// 进入教室的参数
export const fromStrState = atom<string>({
  key: 'fromStr',
  default: ''
})
